import { createOrderFormApp } from '@nx-paeonia/feature-product-configurator';

createOrderFormApp();

document.addEventListener('productConfigurator:opened', () => {
  createOrderFormApp();
});
